// @flow
import ContentWithCategoriesTemplate from './ContentWithCategoriesTemplate';

export default ContentWithCategoriesTemplate;
